<template>
  <Button
    :ui="{ base: 'absolute right-3 top-3 z-10 p-0 h-10 w-10' }"
    color="pink"
    icon="pencil"
    @click="customiseBlock"
  />
</template>

<script lang="ts" setup>
import type { ComputedOptions, ConcreteComponent, MethodOptions } from 'vue'
import type { Block } from '~/types/blocks'

const props = defineProps<{
  block: Block
}>()

const customiseBlock = async () => {
  const customiseBlockModalComponent: Partial<
    Record<BlockType, string | ConcreteComponent<{}, any, any, ComputedOptions, MethodOptions>>
  > = {
    cta: resolveComponent('LazyCustomiseCtaBlockModal'),
    content: resolveComponent('LazyCustomiseContentBlockModal'),
    heading: resolveComponent('LazyCustomiseHeadingBlockModal'),
    image: resolveComponent('LazyCustomiseImageBlockModal'),
    itinerary: resolveComponent('LazyCustomiseItineraryBlockModal'),
    note: resolveComponent('LazyCustomiseNoteBlockModal'),
    text: resolveComponent('LazyCustomiseTextBlockModal')
  }

  const modalComponent = customiseBlockModalComponent[props.block.type]

  if (!modalComponent) {
    return false
  }

  const { openModal } = useModal()

  const updatedBlock = await openModal<Block>(modalComponent, {
    personalisationHashid: getVersionHashidFromUrl(),
    blockHashid: props.block.hashid
  })

  if (updatedBlock?.id) {
    const { updateBlock } = useLandingPage()
    updateBlock(updatedBlock)
  }
}
</script>
